import { WINE_TYPES, WINE_TYPE_LABELS } from '@adega/shared';
import type { Formulario } from '../lib/formularioGarrafa.js';

/** Campos dos dados do vinho — os mesmos no cadastro e na edição. */
export function CamposDoVinho({
  form,
  definir,
}: {
  form: Formulario;
  definir: (campo: keyof Formulario, valor: string) => void;
}) {
  return (
    <>
      <div>
        <label className="label" htmlFor="name">
          Nome *
        </label>
        <input
          id="name"
          className="field"
          value={form.name}
          onChange={(e) => definir('name', e.target.value)}
          placeholder="Ex.: Gran Reserva Touriga Nacional"
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="producer">
            Produtor
          </label>
          <input
            id="producer"
            className="field"
            value={form.producer}
            onChange={(e) => definir('producer', e.target.value)}
          />
        </div>
        <div>
          <label className="label" htmlFor="vintage">
            Safra
          </label>
          <input
            id="vintage"
            type="number"
            className="field"
            value={form.vintage}
            onChange={(e) => definir('vintage', e.target.value)}
            placeholder="Sem safra? deixe vazio"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="type">
            Tipo
          </label>
          <select
            id="type"
            className="field"
            value={form.type}
            onChange={(e) => definir('type', e.target.value)}
          >
            <option value="">Não informado</option>
            {WINE_TYPES.map((tipo) => (
              <option key={tipo} value={tipo}>
                {WINE_TYPE_LABELS[tipo]}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="label" htmlFor="grape">
            Uva
          </label>
          <input
            id="grape"
            className="field"
            value={form.grapeVariety}
            onChange={(e) => definir('grapeVariety', e.target.value)}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="region">
            Região
          </label>
          <input
            id="region"
            className="field"
            value={form.region}
            onChange={(e) => definir('region', e.target.value)}
          />
        </div>
        <div>
          <label className="label" htmlFor="country">
            País
          </label>
          <input
            id="country"
            className="field"
            value={form.country}
            onChange={(e) => definir('country', e.target.value)}
          />
        </div>
      </div>

      {/* O que o rótulo diz além da ficha básica. Nº da garrafa é desta garrafa;
          produção é do vinho. */}
      <h3 className="pt-1 text-sm font-semibold text-adega-muted">Detalhes do rótulo</h3>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="alcohol">
            Teor alcoólico (%)
          </label>
          <input
            id="alcohol"
            type="text"
            inputMode="decimal"
            className="field"
            value={form.alcoholPercent}
            onChange={(e) => definir('alcoholPercent', e.target.value.replace(/[^\d.,]/g, ''))}
            placeholder="13,5"
          />
        </div>
        <div>
          <label className="label" htmlFor="volume">
            Volume (ml)
          </label>
          <input
            id="volume"
            type="text"
            inputMode="numeric"
            className="field"
            value={form.volumeMl}
            onChange={(e) => definir('volumeMl', e.target.value.replace(/\D/g, ''))}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="bottleNumber">
            Nº da garrafa
          </label>
          <input
            id="bottleNumber"
            type="text"
            inputMode="numeric"
            className="field"
            value={form.bottleNumber}
            onChange={(e) => definir('bottleNumber', e.target.value)}
            placeholder="Se for numerada"
          />
        </div>
        <div>
          <label className="label" htmlFor="productionSize">
            Produção (garrafas)
          </label>
          <input
            id="productionSize"
            type="text"
            inputMode="numeric"
            className="field"
            value={form.productionSize}
            onChange={(e) => definir('productionSize', e.target.value.replace(/\D/g, ''))}
            placeholder="Ex.: 1350"
          />
        </div>
      </div>

      <div>
        <label className="label" htmlFor="labelDetails">
          Vinhedo, parcela, terroir…
        </label>
        <input
          id="labelDetails"
          className="field"
          value={form.labelDetails}
          onChange={(e) => definir('labelDetails', e.target.value)}
          placeholder="O que mais o rótulo destaca"
        />
      </div>

      {/* O que não está no rótulo e a IA nunca preenche: quanto custou e onde
          foi comprada. Opcional — só entra no total de quem quiser preencher. */}
      <h3 className="pt-1 text-sm font-semibold text-adega-muted">Compra</h3>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="purchasePrice">
            Valor pago (R$)
          </label>
          <input
            id="purchasePrice"
            type="text"
            inputMode="decimal"
            className="field"
            value={form.purchasePrice}
            onChange={(e) => definir('purchasePrice', e.target.value.replace(/[^\d.,]/g, ''))}
            placeholder="89,90"
          />
        </div>
        <div>
          <label className="label" htmlFor="purchasePlace">
            Onde comprou
          </label>
          <input
            id="purchasePlace"
            className="field"
            value={form.purchasePlace}
            onChange={(e) => definir('purchasePlace', e.target.value)}
            placeholder="Loja, importadora, viagem…"
          />
        </div>
      </div>

      <div>
        <label className="label" htmlFor="notes">
          Observações
        </label>
        <textarea
          id="notes"
          rows={2}
          className="field"
          value={form.notes}
          onChange={(e) => definir('notes', e.target.value)}
          placeholder="Presente de alguém, ocasião especial…"
        />
      </div>
    </>
  );
}
